export const HOUR_DURATION = 60;
